<template>
	<i18n path="recaptcha.attribution" tag="div" class="recaptcha-attribution">
		<a place="privacyLink" :href="privacyLink" target="_blank" rel="external">{{ $t('recaptcha.privacy') }}</a>
		<a place="tosLink" :href="tosLink" target="_blank" rel="external">{{ $t('recaptcha.tos') }}</a>
	</i18n>
</template>

<script>
export default {
	name: 'RecaptchaAttribution',
	computed: {
		tosLink() {
			return 'https://www.nexon.com/main/legal/tou';
		},
		privacyLink() {
			return 'https://www.nexon.com/main/legal/privacy/';
		},
		language() {
			return this.$i18n.locale;
		},
	},
};
</script>

<style lang="less" scoped>
.recaptcha-attribution {
	max-width: 320px;
	font-size: 12px;
	line-height: 1.42;
	margin: 20px auto;
	text-align: left;
	a {
		color: inherit;
		text-decoration: underline;
	}
}
</style>
